import * as $ from 'jquery';
import {FAQelement} from "./faqService";

export class faqComponentJS {

    static init() {
        $('.faqs-group-component').each(function () {
            let Id = $(this).data('category-id');
            faqComponentJS.getFaqByCategory(Id).then((data: FAQelement[]) => {
                faqComponentJS.renderFaqItems(this, data);
            });
        });
        faqComponentJS.initAction();
    };

    static renderFaqItems(elemenet, data) {
        $(elemenet).find('.faqs-group').html(faqComponentJS.generateFaqItems(data));
    }

    static generateFaqItems(data: FAQelement[]) {
        let html = '';
        data.forEach(function (item) {
            html += faqComponentJS.generateFaqItem(item);
        });
        return html;

    }

    static generateFaqItem(data: FAQelement) {
        let html = '<div class="faq-wrapper" key="' + data.id + '">' +
            '                                <div class="faq-question-wrapper">' +
            '                                    <div class="faq-question">' +
            '                                        <h3>' + data.question + '</h3>' +
            '                                    </div>' +
            '                                    <div class="faq-icon">' +
            '                                        <svg height="21.709" width="14.143" viewBox="0 0 14.143 21.709"' +
            '                                             xmlns="http://www.w3.org/2000/svg" class="svg-arrow top"' +
            '                                             data-v-72a9e8e2="">' +
            '                                            <path d="M0,19.158l8.741-8.3L0,2.551,2.691,0,14.143,10.854,2.691,21.709Z"' +
            '                                                  fill="currentColor" data-v-72a9e8e2=""></path>' +
            '                                        </svg>' +
            '                                    </div>' +
            '                                </div>' +
            '                                <div class="faq-answer">' + data.answer + '</div>' +
            '                            </div>';
        return html;

    }


    static getFaqByCategory(catgeoryId: number) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/ajaxGetFaqByCategory/' + catgeoryId,
                type: 'GET',
                dataType: 'json',
                success: function (data) {
                    resolve(data.data);
                },
                error: function (error) {
                    reject(error);
                }
            });
        });
    }

    static initAction() {
        $(document).off('click', '.faq-question-wrapper');
        $(document).on('click', '.faq-question-wrapper', function () {
            const $icon = $(this).find('.faq-icon');
            const $answer = $(this).siblings('.faq-answer');

            $icon.toggleClass('up');
            $answer.toggleClass('show')

            if ($answer.hasClass('show')) {
                const minHeight = $answer.prop('scrollHeight');
                $answer.css('min-height', `${minHeight}px`);
              } else {
                $answer.css('min-height', '0');
              }
        });
    }
}
